import React from "react"

export const DeviceFrame = ({ fit, children }) => {
  return (
    <div className="--device-frame">
      <div className="--device-frame__screen">
        <div
          className={
            "--device-frame__screen__" + (!fit ? "content" : "content-fit")
          }
        >
          {children}
        </div>
      </div>
    </div>
  )
}
